import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function OnlineUsersCounter() {
  const [count, setCount] = useState(47);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial random count between 47 and 89
    setCount(Math.floor(Math.random() * (89 - 47 + 1)) + 47);
    setIsVisible(true);
    const interval = setInterval(() => {
      setCount(prev => {
        const change = Math.floor(Math.random() * 5) - 2; // -2 to +2
        const newCount = prev + change;
        return newCount < 40 ? 40 : newCount > 120 ? 120 : newCount;
      });
    }, 8000);
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-76">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 right-4 z-50 bg-white/90 backdrop-blur-sm shadow-lg rounded-full px-4 py-2 flex items-center gap-2 border border-gray-100" data-id="element-77">
          <span className="relative flex h-3 w-3" data-id="element-78">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-79"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" data-id="element-80"></span>
          </span>
          <span className="text-sm font-medium text-gray-700" data-id="element-81">
            <span className="font-bold text-gray-900" data-id="element-82">{count}</span> personas
            viendo ahora
          </span>
        </motion.div>}
    </AnimatePresence>;
}